import { todayLocal } from "@/lib/dates";

/**
 * A `person_role` assignment is current while it has no end date, or an end
 * date today/in the future. Past end date = a "previous" role.
 */
export function isCurrentAssignment(endDate: string | null): boolean {
  return !endDate || endDate >= todayLocal();
}
